
import SearchOffIcon from "@mui/icons-material/SearchOff";

interface Props {
  text?: string;
}

export const NoItemsFound = ({ text = "No items found" }: Props) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "#666",
        flex: 1,
        width: "100%",
        minHeight: "50vh",
      }}
    >
      <SearchOffIcon sx={{ fontSize: 60, marginBottom: 2, color: "#ccc" }} />
      <div style={{ fontSize: 18 }}>{text}</div>
    </div>
  );
};
